import { computed } from 'vue';
//import { useMobileDetection } from 'vue3-mobile-detection';

// モバイル判定
const isMobile = computed(() => {
  //管理システムはOSにより利用できる機能が替わるので、モバイル判定は画面サイズではなくユーザーエージェントで行う
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (
    userAgent.indexOf('iphone') != -1 ||
    userAgent.indexOf('ipad') != -1 ||
    userAgent.indexOf('android') != -1 ||
    userAgent.indexOf('mobile') != -1
  ) {
    return true;
  } else {
    return false;
  }
});

const getOs = computed(() => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('windows nt') !== -1) {
    return 'windows';
  } else if (userAgent.indexOf('android') !== -1 || userAgent.indexOf('mobile') != -1) {
    return 'android';
  } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
    return 'iphone';
  } else if (userAgent.indexOf('mac os x') !== -1) {
    return 'mac';
  } else {
    return 'linux'; //不明な場合はlinux扱い
  }
});

const getBrowser = computed(() => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (
    userAgent.indexOf('edge') !== -1 ||
    userAgent.indexOf('edga') !== -1 ||
    userAgent.indexOf('edgios') !== -1 ||
    userAgent.indexOf('edg') !== -1
  ) {
    return 'edge';
  } else if (userAgent.indexOf('chrome') !== -1 || userAgent.indexOf('crios') !== -1) {
    return 'chrome';
  } else if (userAgent.indexOf('firefox') !== -1 || userAgent.indexOf('fxios') !== -1) {
    return 'firefox';
  } else if (userAgent.indexOf('safari') !== -1) {
    return 'safari';
  } else {
    return 'other';
  }
});

const createPasswordInformation = computed(() => {
  let howto = '';
  let helpUrl = '';

  const os = getOs.value;
  const browser = getBrowser.value;
  //edge
  if (browser == 'edge') {
    helpUrl =
      'https://support.microsoft.com/ja-jp/topic/%E3%83%91%E3%82%B9%E3%83%AF%E3%83%BC%E3%83%89-%E3%82%B8%E3%82%A7%E3%83%8D%E3%83%AC%E3%83%BC%E3%82%BF%E3%83%BC%E3%82%92%E4%BD%BF%E7%94%A8%E3%81%97%E3%81%A6-%E3%82%BB%E3%82%AD%E3%83%A5%E3%83%AA%E3%83%86%E3%82%A3%E3%81%A7%E4%BF%9D%E8%AD%B7%E3%81%95%E3%82%8C%E3%81%9F%E3%83%91%E3%82%B9%E3%83%AF%E3%83%BC%E3%83%89%E3%82%92%E4%BD%9C%E6%88%90microsoft-edge-e9247e35-684b-4114-bb5e-fdea3e4ae3ff';
    howto +=
      '複雑なパスワードを作成するには、パスワード入力欄を右クリックし「強力なパスワードの提案」メニューより作成を行って下さい。';
    //chrome
  } else if (browser == 'chrome' && os == 'iphone') {
    helpUrl =
      'https://support.google.com/chrome/answer/7570435?hl=ja&co=GENIE.Platform%3DiOS&oco=1';
    howto +=
      '複雑なパスワードを作成するには、パスワード入力欄をタップし「パスワードを自動生成」メニューより作成を行って下さい。';
  } else if (browser == 'chrome' && os == 'android') {
    helpUrl =
      'https://support.google.com/chrome/answer/7570435?hl=ja&co=GENIE.Platform%3DAndroid&oco=1';
    howto +=
      '複雑なパスワードを作成するには、パスワード入力欄をタップし「パスワードを自動生成」メニューより作成を行って下さい。';
  } else if (browser == 'chrome') {
    helpUrl =
      'https://support.google.com/chrome/answer/7570435?hl=ja&co=GENIE.Platform%3DDesktop&oco=1';
    howto +=
      '複雑なパスワードを作成するには、パスワード入力欄を右クリックし「パスワードを自動生成」メニューより作成を行って下さい。';
    //safari
  } else if (browser == 'safari' && os == 'iphone') {
    helpUrl = 'https://support.apple.com/ja-jp/guide/iphone/iphf9219d8c9/ios';
    howto +=
      '複雑なパスワードを作成するには、パスワード入力欄をタップし「強力なパスワードを使用」メニューより作成を行って下さい。';
  } else if (browser == 'safari') {
    helpUrl = 'https://support.apple.com/ja-jp/guide/security/secc84c811c4/web';
    howto +=
      '複雑なパスワードを作成するには、パスワード入力欄をクリックし「新しいパスワード候補を表示」メニューより作成を行って下さい。';
    //firefox
  } else if (browser == 'firefox' && (os == 'iphone' || os == 'android')) {
    helpUrl = 'https://support.mozilla.org/ja/kb/how-generate-secure-password-firefox';
    howto +=
      '複雑なパスワードを作成するには、パスワード入力欄をタップし「安全に生成されたパスワードを使用」メニューより作成を行って下さい。';
  } else if (browser == 'firefox') {
    helpUrl = 'https://support.mozilla.org/ja/kb/how-generate-secure-password-firefox';
    howto +=
      '複雑なパスワードを作成するには、パスワード入力欄をクリックし「安全に生成されたパスワードを使用」メニューより作成を行って下さい。';
  } else {
    helpUrl = '';
    howto +=
      'パスワード入力欄をクリック又は右クリック（スマートフォンの場合はタップ）で、複雑なパスワード生成を行う機能があれば、その機能をお使いいただく事をお勧めします。お使いブラウザの公式ページなどをご確認ください。';
  }

  let information = '' + howto;

  //デバッグ用
  //information += window.navigator.userAgent.toLowerCase();

  if (helpUrl) {
    information +=
      'メニューが表示されない方は<a href="' +
      helpUrl +
      '" target="_blank">こちらのヘルプページ</a>をご確認ください。';
  } else {
    information += 'メニューが表示されない方はご利用ブラウザのヘルプページをご確認ください。';
  }

  return information;
});
export { isMobile, createPasswordInformation };
